import React, { Component } from 'react';
import './ContactUsPage.scss';
import { required, email, phone } from '../../Validation/GeneralValidators';
import Form from 'react-validation/build/form';
import {
  sendContact,
  createSendContactResetAction
} from '../../Actions/Contact';
import {
  DonationInput as Input,
  DonationTextarea as Textarea,
  DonationButton as Button
} from '../../Validation/Form';
import { connect } from 'react-redux';

class ContactUsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: {
        isUsed: false,
        value: ''
      },
      lastname: {
        isUsed: false,
        value: ''
      },
      telephone: {
        isUsed: false,
        value: ''
      },
      email: {
        isUsed: false,
        value: ''
      },
      message: {
        isUsed: false,
        value: ''
      }
    };
  }

  componentDidMount(props) {
    // reset the state everytime the component is mounted
    this.props.sendContactReset();
  }

  handleInputChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: {
        isUsed: true,
        value: value
      }
    });
  };

  sendContact = event => {
    event.preventDefault();
    const postData = {
      firstname: this.state.firstname.value,
      lastname: this.state.lastname.value,
      telephone: this.state.telephone.value,
      email: this.state.email.value,
      message: this.state.message.value
    };
    this.props.sendContact(postData);
    this.setState({
      firstname: {
        isUsed: false,
        value: ''
      },
      lastname: {
        isUsed: false,
        value: ''
      },
      telephone: {
        isUsed: false,
        value: ''
      },
      email: {
        isUsed: false,
        value: ''
      },
      message: {
        isUsed: false,
        value: ''
      }
    });
  };

  render() {
    return (
      <div className="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2 contactPage">
        <Form onSubmit={this.sendContact} ref={c => (this.form = c)}>
          <div className="row">
            <div className="col-lg-12 text-center">
              <h2 className="section-header">Kontakt</h2>
              <p className="section-header-subtitle">
                Bitte füllen Sie das untenstehende Formular aus und wir werden
                uns so schnell wie moglich bei Ihnen melden.
              </p>
            </div>
          </div>

          <div className="row">
            <Input
              label={'Vorname'}
              name={'firstname'}
              value={this.state.firstname.value}
              isUsed={this.state.firstname.isUsed}
              onChange={this.handleInputChange}
              type="text"
              validations={[required]}
              sublabel={'(Pflichtfeld)'}
            />

            <Input
              label={'Nachname'}
              name={'lastname'}
              value={this.state.lastname.value}
              isUsed={this.state.lastname.isUsed}
              onChange={this.handleInputChange}
              type="text"
              validations={[]}
            />
          </div>
          <div className="row">
            <Input
              label={'E-Mail'}
              name={'email'}
              value={this.state.email.value}
              isUsed={this.state.email.isUsed}
              onChange={this.handleInputChange}
              type="email"
              validations={[required, email]}
              sublabel={'(Pflichtfeld)'}
            />

            <Input
              label={'Telefonnummer'}
              name={'telephone'}
              value={this.state.telephone.value}
              onChange={this.handleInputChange}
              isUsed={this.state.telephone.isUsed}
              validations={[required, phone]}
              type="number"
              pattern="[0-9]*"
              sublabel={'(Pflichtfeld)'}
            />
          </div>
          <div className="row">
            <Textarea
              label={'Nachricht'}
              name={'message'}
              value={this.state.message.value}
              onChange={this.handleInputChange}
              isUsed={this.state.message.isUsed}
              rows={8}
              type="text"
              validations={[required]}
              sublabel={'(Pflichtfeld)'}
              style={{
                resize: 'none'
              }}
            />
          </div>
          <div className="row">
            <div className="form-inline col-md-12 text-center">
              <Button
                className="btn btn-default btnSubmit"
                disabled={this.props.fetching}
              >
                Senden
              </Button>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    fetching: state.contactReducer.fetching,
    error: state.contactReducer.error,
    success: state.contactReducer.success
  };
};

const mapDispatchToProps = dispatch => {
  return {
    sendContact: data => dispatch(sendContact(data)),
    sendContactReset: () => dispatch(createSendContactResetAction())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactUsPage);



// WEBPACK FOOTER //
// ./src/Containers/Pages/ContactUsPage.js